import { useLocation, useNavigate } from 'react-router'

export const REDIRECT_KEY = 'REDIRECT_TO'

export const useRedirect = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const storeLastLocation = () => {
        localStorage.setItem(REDIRECT_KEY, location.pathname.replace(/^\/|\/$/g, ''))
    }

    const redirectTo = () => {
        const to = localStorage.getItem(REDIRECT_KEY)
        if (to) {
            localStorage.removeItem(REDIRECT_KEY)
            navigate(to, { replace: true })
        }
    }

    return { storeLastLocation, redirectTo }
}
